export function getUserRoles(user) {
  if (!user || !Array.isArray(user.roles)) {
    return [];
  }

  return user.roles;
}

export function hasRole(user, role) {
  return getUserRoles(user).includes(role);
}

export function isViewer(user) {
  return hasRole(user, 'ROLE_VIEWER');
}

export const VIEWER_ALLOWED_TABS = [
  'dashboard',
  'comparison_old',
  'ebay-top-sales',
];
